import Text from "./Text";
import "./Faq.css";

const FaqText = () => {
  return (
    <ul className="faq-list">
      <li>
        <Text type="disclaimer-title">What should I expect when I use the Cabana pod?</Text>
        <Text type="disclaimer">The Cabana pod offers a private, safe space for you to mentally reset during your workday.  Use the provided tablet to select a setting and guided exercise to immerse yourself in a virtual oasis.  Plan to spend about 5-10 minutes in the pod. Please share feedback when you’re done!</Text>
      </li>
      <li>
        <Text type="disclaimer-title">How do I reserve time in the Cabana pod?</Text>
        <Text type="disclaimer">No reservation is needed. If the pod is empty, it’s ready for use.</Text>
      </li>
      <li>
        <Text type="disclaimer-title">Is there a limit to how much time I can spend in the Cabana pod?</Text>
        <Text type="disclaimer">There’s no strict time limit, but please be considerate of others who may want to use it. Exercises typically last 4-10 minutes.</Text>
      </li>
      <li>
        <Text type="disclaimer-title">Do I have to use the tablet? Can I meditate on my own?</Text>
        <Text type="disclaimer">Using the tablet enhances the experience, but you’re welcome to meditate on your own. Just keep the Pod’s intended purpose in mind.</Text>
      </li>
      <li>
        <Text type="disclaimer-title">How often is the Cabana pod sanitized?</Text>
        <Text type="disclaimer">Pods are thoroughly cleaned regularly. If additional cleaning is needed, please email support@yourcabana.com.</Text>
      </li>
      <li>
        <Text type="disclaimer-title">Where do I go for more tools to recharge?</Text>
        <Text type="disclaimer">Cabana offers daily mental health support and tools accessible via an iOS app or your browser. Visit www.yourcabana.com to create your Cabana Live account and get unlimited access to our live groups, guided journal, and on-demand content library.</Text>
        </li>
      <li>
        <Text type="disclaimer-title">Who do I contact if something is wrong with the Cabana pod?</Text>
        <Text type="disclaimer">For any issues or suggestions, email us at support@yourcabana.com.</Text>
       </li>
    </ul>
  );
};

export default FaqText;
